import styled from 'styled-components';
import { GetMobileStyledCompImg } from 'common-modules/general/Modules/functions';

export const CloseIcon = styled.i`
  width: 20px;
  width: 1.25rem;
  height: 20px;
  height: 1.25rem;
  background: url(${GetMobileStyledCompImg('common/ico_toast_close.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 20px 20px;
`;
export const BlackCloseIcon = styled.i`
  width: 0.75rem;
  height: 0.75rem;
  background: url(${GetMobileStyledCompImg('common/ico_close.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 12px 12px;
`;
export const BurgerIcon = styled.i`
  display: inline-block;
  vertical-align: middle;
  width: 1.5rem;
  height: 0.90625rem;
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 1.5rem 0.90625rem;
  background-image: url(${GetMobileStyledCompImg('common/ico_all_menu01.png')});
`;

export const BlackBurgetIcon = styled.i`
  display: inline-block;
  vertical-align: middle;
  width: 1.5rem;
  height: 0.90625rem;
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 1.5rem 0.90625rem;
  background-image: url(${GetMobileStyledCompImg('common/ico_all_menu02.png')});
`;

export const FtSearchIcon = styled.span`
  width: 45px;
  width: 2.8125rem;
  height: 35px;
  height: 2.1875rem;
  background: url(${GetMobileStyledCompImg('main/mo-wt-main-quick-menu-2.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 45px 35px;
`;

export const FtPeopleIocn = styled.span`
  width: 3.1875rem;
  height: 2.55rem;
  background: url(${GetMobileStyledCompImg('main/mo-wt-main-quick-menu-4.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 35px 36px;
`;

export const FtBuildingIcon = styled.span`
  width: 3.375rem;
  height: 2.3125rem;
  background: url(${GetMobileStyledCompImg('main/mo-wt-main-quick-menu-5.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 54px 37px;
`;

export const FtPlanIcon = styled.span`
  width: 2.5625rem;

  height: 2.125rem;
  background: url(${GetMobileStyledCompImg('common/ico_plan.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 41px 34px;
`;

export const FtToolIcon = styled.span`
  width: 1.875rem;
  height: 1.875rem;
  background: url(${GetMobileStyledCompImg('common/ico_tool.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 30px 30px;
`;

export const FtBookIcon = styled.span`
  width: 2.75rem;

  height: 2.1875rem;
  background: url(${GetMobileStyledCompImg('common/ico_book.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 44px 35px;
`;

export const FtEventIcon = styled.span`
  width: 2.8125rem;
  height: 2.1875rem;
  background: url(${GetMobileStyledCompImg('common/ico_event.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 45px 35px;
`;

export const FtFactoryIcon = styled.span`
  width: 2.8125rem;
  height: 1.25rem;
  background: url(${GetMobileStyledCompImg('common/ico_factory.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 45px 20px;
`;

export const FtSymbolIcon = styled.span`
  width: 2.625rem;
  height: 1.25rem;
  background: url(${GetMobileStyledCompImg('common/ico_symbol.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 42px 20px;
`;

export const FtFilterIcon = styled.span`
  width: 2.625rem;
  height: 1.625rem;
  background: url(${GetMobileStyledCompImg('common/ico_filter.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 42px 26px;
`;

export const PopupCloseIcon = styled.i`
  display: inline-block;
  width: 0.8125rem;
  height: 0.8125rem;
  background: url(${GetMobileStyledCompImg('common/ico_close_layerpopup01.png')}) no-repeat center center;
  background-size: 13px 13px;
  background-size: 0.8125rem 0.8125rem;
`;

export const NextArrowIcon = styled.span`
  width: 0.5rem;
  height: 0.875rem;
  background: url(${GetMobileStyledCompImg('common/ico_next_arrow.png')}) no-repeat 0 0;
  display: inline-block;
`;
export const UpArrowIcon = styled.i`
  width: 0.9375rem;
  height: 0.5rem;
  background: url(${GetMobileStyledCompImg('common/ico_down_arrow.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 15px 8px;
`;

export const NoResultIcon = styled.i`
  background-image: url(${GetMobileStyledCompImg('common/ico_no_result.png')});
  display: inline-block;
  width: 62px;
  height: 62px;
  background-size: 62px 62px;
  background-repeat: no-repeat;
`;
